<script>
  import MarkdownBlock from '/components/Atoms/MarkdownBlock'
  import SideGroup from '/Groups/SideGroup'
  import CardMainContent from '/components/Widgets/CardMainContent'
  import Related from '/components/Groups/Related'
  import Body from '/Groups/Body'
  import Link from '/Atoms/Link'
  import EventDate from '/Atoms/EventDate'

  export let data

  let event = data?.Event || {}

  const title = event?.title

  const body = event?.body || []

  const buyTicketUrl = event?.buyTicketUrl
  const buyTicketTitle = event?.buyTicketTitle || buyTicketUrl

  const eventDates = event?.eventDates || []

  const venues = event?.relatedVenues || []
  const location = event?.location

  const formats = (event?.eventformat || []).map(f => f.toUpperCase()).join(", ")

  const participantGroups = event?.relatedPeople?.filter(p => p.relationshipType === "participant") || []
  const participants = []
  for (let group of participantGroups) {
    if (group.members && group.members.length > 0) participants.push(...group.members)
  }

  const sideWidgets = event?.relatedWidgets || []


</script>

<div class="container">

  <section class="main">
    <CardMainContent
      category={null}
      title={ title }
      sup={formats}
    >

      <div slot="headercontent">
        <ul class="people">
          {#each participants as person}
            <li>
              <Link markdown section="people" slug={person.slug}>
                {person.title}
              </Link>
            </li>
          {/each}
        </ul>

        {#if eventDates.length > 0 || venues.length > 0 || location || buyTicketUrl}
          <p class="datePlaceBook">
            {#each eventDates as date}
              <EventDate startDate={date.startDateAndTime} endDate={date.endDateAndTime}/>
            {/each}
            {#if location}
              <div class="venue">
                {location}
              </div>
            {/if}
            {#each venues as venue}
              <ul>
                <li class="venue">
                <Link markdown section="venues" slug={venue.slug}>
                  {venue.title}
                </Link>
                </li>
              </ul>
            {/each}
            {#if buyTicketUrl}
              <div class="ticketlink">
                <Link markdown href={buyTicketUrl}>
                  {buyTicketTitle}
                </Link>
              </div>
            {/if}
          </p>
        {/if}

      </div>

      <Body {body} />

    </CardMainContent>

    <Related data={event} />

  </section>

  <aside class="side">
    <SideGroup widgets={sideWidgets} />
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  a {
    @include typo-grotesk-text-24;
  }

  .datePlaceBook {
    margin-top: 1em;
  }

  .people {
    li {
      display: inline;
      &:not(:last-child)::after {
        content: ", ";
      }
    }
  }

</style>